module.exports = __webpack_public_path__ + "img/vlx-marica-merciless-vlx-marica-2.61917364.jpg";